// extracted by mini-css-extract-plugin
export default {"container":"AboutText_container__tgB+5","who_we_are":"AboutText_who_we_are__CCVP-","what_we_do":"AboutText_what_we_do__lyT-2"};